
import perfil from "./assets/perfil.svg";
import rede  from "./assets/rede.png";
export const featuredList = [
    {
      id: 1,
      title: "Uma rede social para desenvolvedores",
      img:`${rede}`,
      link:'https://devsocialnetwork.netlify.app/'
        
    },
    {
      id: 2,
      title: "Em breve",
      img:`${perfil}`
    },
    {
      id: 3,
      title: "Em breve",
      img:`${perfil}`
    },
    {
      id: 4,
      title: "Em breve",
      img:`${perfil}`
    },
 
  ];
  
  export const webList= [
    {
      id: 1,
      title: "Uma rede social para desenvolvedores",
      img:`${rede}`,
      link:'https://devsocialnetwork.netlify.app/'
        
    },
    {
      id: 2,
      title: "Em breve",
      img:`${perfil}`
    },
    {
      id: 3,
      title: "Em breve",
      img:`${perfil}`
    },
   
 
  ];
  
  export const appList = [
    {
      id: 1,
      title: "Em breve",
      img:`${perfil}`,
      link:'https://stackoverflow.com/questions/44147937/property-does-not-exist-on-type-never'
        
    },
    {
      id: 2,
      title: "Em breve",
      img:`${perfil}`
    },
    {
      id: 3,
      title: "Em breve",
      img:`${perfil}`
    },
    {
      id: 4,
      title: "Em breve",
      img:`${perfil}`
    },
 
 
  ];
  
  export const designList = [
    {
      id: 1,
      title: "Em breve",
      img:`${perfil}`,
      link:'https://stackoverflow.com/questions/44147937/property-does-not-exist-on-type-never'
        
    },
    {
      id: 2,
      title: "Em breve",
      img:`${perfil}`
    },
  
 
  ];
  
  export const brandingList = [
    {
      id: 1,
      title: "Em breve",
      img:`${perfil}`,
      link:'https://stackoverflow.com/questions/44147937/property-does-not-exist-on-type-never'
        
    },
    {
      id: 2,
      title: "Em breve",
      img:`${perfil}`
    },
    {
      id: 3,
      title: "Em breve",
      img:`${perfil}`
    },
   
 
  ];
  